import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './accordion.css';
var cx = classnames.bind(styles);

function renderContent(content) {
  return typeof content === 'function' ? content() : content;
}

export default function Accordion(_ref) {
  var items = _ref.items,
      bordered = _ref.bordered,
      expandAll = _ref.expandAll,
      rest = _objectWithoutProperties(_ref, ["items", "bordered", "expandAll"]);

  var _useState = useState(expandAll ? items.map(function (item, i) {
    return i;
  }) : []),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndexes = _useState2[0],
      setActiveIndexes = _useState2[1];

  var toggleHandlers = useMemo(function () {
    return items.map(function (item, i) {
      return function () {
        var newActiveIndexes = activeIndexes.includes(i) ? activeIndexes.filter(function (x) {
          return x !== i;
        }) : activeIndexes.concat(i);
        setActiveIndexes(newActiveIndexes);
      };
    });
  }, [activeIndexes, items.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return React.createElement("ul", _extends({
    className: cx('list', {
      bordered: bordered
    }),
    role: "presentation"
  }, rest), items.map(function (item, i) {
    var isActive = activeIndexes.includes(i);
    return React.createElement("li", {
      className: activeIndexes.includes(i) ? styles.active : undefined,
      key: item.label
    }, React.createElement("div", {
      role: "heading"
    }, React.createElement("button", {
      "aria-controls": "accordion_content_".concat(i),
      "aria-expanded": isActive,
      className: styles.toggle,
      id: "accordion_label_".concat(i),
      onClick: toggleHandlers[i],
      type: "button"
    }, React.createElement(FontAwesomeIcon, {
      className: styles.icon,
      icon: isActive ? faMinusCircle : faPlusCircle,
      size: "2x"
    }), React.createElement("span", {
      className: styles.text
    }, item.label))), React.createElement("div", {
      "aria-hidden": !isActive,
      "aria-labelledby": "accordion_label_".concat(i),
      className: styles.content,
      id: "accordion_content_".concat(i),
      role: "region"
    }, renderContent(item.content)));
  }));
}
Accordion.propTypes = {
  /** An array of accordion items */
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired
  })),

  /** Boolean to add borders to accordion elements */
  bordered: PropTypes.bool,

  /** Boolean to expand all accordion items when first mounting the component */
  expandAll: PropTypes.bool
};
Accordion.defaultProps = {
  items: [],
  bordered: false,
  expandAll: false
};